import { createContext, useContext, useMemo } from "react"
const TableMainContext = createContext()

/**
 * Proveedor de contexto para el plan anual.
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componentes hijos.
 * @param {array} props.data
 * @param {array} props.items
 * @param {object} props.options
 */
export function TableMainContextProvider({ data = [], options = {}, items, children }) {
	const datos = useMemo(
		() => ({
			data,
			items,
			options,
		}),
		[data, items, options]
	)
	return <TableMainContext.Provider value={datos}>{children}</TableMainContext.Provider>
}

/**
 * @typedef {Object} TableMainContextParams
 * @property {array} props.data
 * @property {array} props.items
 * @property {object} props.options
 */

/**
 * Hook para acceder al contexto de creación del plan anual.
 * @returns {TableMainContextParams}
 */

export function useTableMainContext() {
	return useContext(TableMainContext)
}
